import {User}								from '../user/interface';

import * as API								from '../../ressources/API';


export default {
	getMobileLinesApi: async (user: User) => {
		const response = await API.getMobileLine(user);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	getMobileLinesUsageApi: async (phoneNumber: string, serial: string, user: User) => {
		const response = await API.getMobileLineUsage(phoneNumber, serial, user);
		if (!response || !response.status)
			return [];
		return response.data;
	}
};
